import React, { useState } from 'react';
import { Select, Empty, Icon, Card, Tabs, Row, Col } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faRegistered } from '@fortawesome/free-solid-svg-icons';
import { allNations } from './../utils/countries';
import CustomAvatar from './../components/customAvatar';
import moment from 'moment';
import { nameStyle, roleStyle } from './../theme';
import Flag from "react-country-flags";
import parse from 'html-react-parser';
import CandidateEventsList from './../components/candidateEventsList';
import { EVENT_TYPE } from './../utils';

const { orderBy } = require('lodash');
const { TabPane } = Tabs;
const { Option } = Select;

function CandidateDetail(props) {
  const nations = allNations()
  const candidate = props.data;

  const eventsTypeArr = orderBy(Object.keys(EVENT_TYPE).map(e => {
    return EVENT_TYPE[e]
  }));

  const [eventType, setEventType] = useState(EVENT_TYPE.all.name);

  const eventTypeSelection = [];
  for (let i = 0; i < eventsTypeArr.length; i++) {
    eventTypeSelection.push(
      <Option key={eventsTypeArr[i].name} value={eventsTypeArr[i].name}>
        {eventsTypeArr[i].text}
      </Option>
    )
  }

  const getEvents = (eventType, data) => {
    let events = data;
    if (eventType !== 'all') {
      events = data.filter(i => i.type === eventType)
    }
    return events
  }

  const cardTitle = (candidate) => {
    const countryCode = nations.find(i => i.name === candidate.country);
    return(
      <center>
        <CustomAvatar
          colourCode={candidate.firstname.charAt(0).toLowerCase()}
          char={`${candidate.firstname.charAt(0).toUpperCase()}${candidate.lastname.charAt(0).toUpperCase()}`}
          charSize={30}
          size={86}
          src={candidate.avatar}
        />

        <div style={{marginTop: "15px"}}>
          <p style={nameStyle}>
            {candidate.salutation} {candidate.firstname} {candidate.lastname}
          </p>

          {
            candidate.country && candidate.country !== "" ?
            <div>
              <Flag country={countryCode.code} asSquare={true} style={{width: '40px', height: '30px'}}/>
            </div>
            :
            null
          }

          {
            candidate.linkedin && candidate.linkedin !== "" ?
            <React.Fragment>
            <br/>
            <p style={roleStyle} onClick={() => {
              window.open(candidate.linkedin, '_blank');
            }}>
              <span style={{cursor: "pointer"}}>go to linkedin</span>
            </p>
            </React.Fragment>
            :
            null
          }
        </div>
      </center>
    )
  }

  return (
    <Row style={{
      maxHeight: '400px',
      overflow: 'auto'
    }}>
      <Col span={6}>
        <div style={{marginRight: '5px'}}>
          <Card title={cardTitle(candidate)} bordered={true}>
            <div style={{marginTop: '-25px'}}>

              <React.Fragment>
                <br/>
                <div><FontAwesomeIcon icon={faRegistered} />&nbsp;<b>Reference</b></div>
                <div>{candidate.reference}</div>
              </React.Fragment>

              {
                candidate.region && candidate.region !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<b>Region</b></div>
                  <div>{candidate.region}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.dob && candidate.dob !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b></div>
                  <div>{moment(candidate.dob).format('YYYY-MM-DD')}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.email !== "" || candidate.email1 !== "" || candidate.email2 !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="mail" theme="filled" /> <b>Email</b></div>
                  {
                    candidate.email !== "" ?
                    <div>{candidate.email}</div>
                    :
                    null
                  }
                  {
                    candidate.email1 !== "" ?
                    <div>{candidate.email1}</div>
                    :
                    null
                  }
                  {
                    candidate.email2 !== "" ?
                    <div>{candidate.email2}</div>
                    :
                    null
                  }
                </React.Fragment>
                :
                null
              }

              {
                candidate.mobile && candidate.mobile !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="mobile" theme="filled" /> <b>Mobile</b></div>
                  <div>{candidate.mobile}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.location && candidate.location !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faMapMarkedAlt} /> <b>Location</b></div>
                  <div>{candidate.location}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.service && candidate.service !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faBriefcase} /> <b>Service</b></div>
                  <div>{candidate.service}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.position && candidate.position !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faUserTie} /> <b>Position</b></div>
                  <div>{candidate.position}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.wechat && candidate.wechat !== "" ?
                <React.Fragment>
                  <br/>
                  <div><Icon type="wechat" theme="filled" /> <b>Wechat</b></div>
                  <div>{candidate.wechat}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.whatsapp && candidate.whatsapp !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faPhoneVolume} /> <b>Whats App</b></div>
                  <div>{candidate.whatsapp}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.othercontact && candidate.othercontact !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faExclamationCircle} /> <b>Other Contact</b></div>
                  <div>{candidate.othercontact}</div>
                </React.Fragment>
                :
                null
              }

              {
                candidate.source && candidate.source !== "" ?
                <React.Fragment>
                  <br/>
                  <div><FontAwesomeIcon icon={faInfoCircle} /> <b>Source</b></div>
                  <div>{candidate.source}</div>
                </React.Fragment>
                :
                null
              }

            </div>
          </Card>
        </div>
      </Col>

      <Col span={18}>
        <Tabs type="card">
          <TabPane tab="Events" key="events">

            <Row>
              <Col span={8}>
                <div>
                  <Select
                    value={eventType}
                    style={{ width: 220 }} onChange={(value) => {setEventType(value)}}
                  >
                  {eventTypeSelection}
                  </Select>
                </div>
              </Col>
            </Row>
            <br/>

            <CandidateEventsList
              contactID={candidate.id}
              data={getEvents(eventType, candidate.events)}
              disableRemove={true}
            />
          </TabPane>
          <TabPane tab="Notes" key="notes">
          {
            candidate.notes && candidate.notes !== "" ?
              parse(candidate.notes)
            :
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          }
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  );
}

export default CandidateDetail;
